import React, {Component} from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <span><a href="http://coreui.io/pro/">CoreUI Pro</a> &copy; 2018 creativeLabs.</span>
        <span className="ml-auto">Powered by <a href="http://coreui.io/pro/">CoreUI Pro</a></span>
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js